(function () {
  function toggleColumn(heading) {
    var column = heading.closest('.origin-comp__column');
    if (!column) return;
    var isOpen = column.classList.toggle('is-open');
    heading.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var heading = e.target.closest('[data-oc-toggle]');
    if (heading) toggleColumn(heading);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var heading = e.target.closest('[data-oc-toggle]');
    if (heading) {
      e.preventDefault();
      toggleColumn(heading);
    }
  });
})();